/**
 * Admin API for per-state content — see state_content/views.py and
 * docs/plans/state-content.md. The tenant has one `state_content` form (its
 * schema is designed in the form builder); each state's content is one row of
 * it, created the first time an admin opens that state. Content itself is
 * saved through formkit's own endpoints (the FormRenderer), so all this module
 * resolves is ids.
 */
import apiClient from './client';

export const stateContentApi = {
  /** The tenant's singleton state-content form id. */
  getForm: (): Promise<{ id: number }> =>
    apiClient.get('/state-content/current/').then((res) => res.data),

  /** One state's content row, created on first request. */
  getStateRow: (formId: number, code: string): Promise<{ id: number; state: string; full_name: string }> =>
    apiClient
      .post(`/state-content/${formId}/state_row/`, { state: code })
      .then((res) => res.data),
};
